import React, { useState, useEffect, useContext, createContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const BreakpointContext = createContext({});

const BreakpointsProvider = ({ children }) => {
  const theme = useTheme();

  // These are *values*, not functions
  const upSm = useMediaQuery(theme.breakpoints.up("sm"));
  const downSm = useMediaQuery(theme.breakpoints.down("sm"));
  const onlySm = useMediaQuery(theme.breakpoints.only("sm"));
  const betweenSmMd = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const isXs = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "xl"));
  const isXl = useMediaQuery(theme.breakpoints.between("xl", "2xl"));
  const is2Xl = useMediaQuery(theme.breakpoints.up("2xl"));

  const [currentBreakpoint, setCurrentBreakpoint] = useState("xs");

  useEffect(() => {
    if (isXs) setCurrentBreakpoint("xs");
    else if (isSm) setCurrentBreakpoint("sm");
    else if (isMd) setCurrentBreakpoint("md");
    else if (isLg) setCurrentBreakpoint("lg");
    else if (isXl) setCurrentBreakpoint("xl");
    else if (is2Xl) setCurrentBreakpoint("2xl");
  }, [isXs, isSm, isMd, isLg, isXl, is2Xl]);

  return (
    <BreakpointContext.Provider
      value={{
        currentBreakpoint,
        upSm,
        downSm,
        onlySm,
        betweenSmMd,
        isXs,
        isSm,
        isMd,
        isLg,
        isXl,
        is2Xl,
      }}
    >
      {children}
    </BreakpointContext.Provider>
  );
};

export const useBreakpoints = () => useContext(BreakpointContext);

export default BreakpointsProvider;
